module.exports = __webpack_public_path__ + "img/banner-two7.8e770688.png";